export enum InvoiceMissionTypeEnum {
  None = '0',
  Gift = '-1',
  MemberFee = '-2',
  Purchase = '-3',
  Subscription = '-4',
}
